import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Table from "src/componets/Table";
import Pagination from "src/componets/Pagination";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { RateHistoryInterface } from "src/store/callrecorder/rateHistoriesSlice";
import { fetchRateHistories } from "src/actions/callrecorder/rateHistoriesActions";
import { formattedDate } from "src/helpers/DateHelpers";
import { queryParams } from "src/helpers/UrlHelpers";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import OptionalLink from "src/componets/OptionalLink";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

const LIMIT = 42;

const _RateHistories = ({ csvImportId, processedRows }: { csvImportId: string | undefined, processedRows?: number }) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;

  const ids = useAppSelector(state => state.callrecorder.rateHistories.ids);
  const entities = useAppSelector(state => state.callrecorder.rateHistories.entities);
  const count = useAppSelector(state => state.callrecorder.rateHistories.count);
  const data = ids ? ids.map(id => entities[id]) : [];

  useEffect(() => {
    if (csvImportId) {
      dispatch(fetchRateHistories({
        csv_import_id: csvImportId,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      }));
    }
  }, [csvImportId, currentPage, processedRows, dispatch]);

  const columns: ColumnsType<RateHistoryInterface> = [
    {
      key: 'rate_id',
      title: 'Rate',
      render: (_, { rate_id }) => (
        <OptionalLink link={callrecorderUrls.ratePath(rate_id)}>
          {`#${rate_id}`}
        </OptionalLink>
      ),
      width: 100
    },

    {
      key: 'cost_per_min',
      title: 'Cost / Min',
      render: (_, record) => {
        const changed = record.previous_cost_per_min !== record.new_cost_per_min;
        return (
          <span>
            <small style={changed ? { background: '#fff1f0', padding: '1px 4px', borderRadius: 3 } : {}}>{record.previous_cost_per_min}</small>
            {' '}<ArrowRightOutlined style={{ fontSize: 10, color: '#999' }} />{' '}
            <small style={changed ? { background: '#f6ffed', padding: '1px 4px', borderRadius: 3 } : {}}><strong>{record.new_cost_per_min}</strong></small>
          </span>
        );
      },
      width: 160
    },

    {
      key: 'raw_cost',
      title: 'Raw Cost',
      render: (_, record) => {
        const changed = record.previous_raw_cost !== record.new_raw_cost;
        return (
          <span>
            <small style={changed ? { background: '#fff1f0', padding: '1px 4px', borderRadius: 3 } : {}}>{record.previous_raw_cost}</small>
            {' '}<ArrowRightOutlined style={{ fontSize: 10, color: '#999' }} />{' '}
            <small style={changed ? { background: '#f6ffed', padding: '1px 4px', borderRadius: 3 } : {}}><strong>{record.new_raw_cost}</strong></small>
          </span>
        );
      },
      width: 160
    },

    {
      key: 'currency',
      title: 'Currency',
      render: (_, { new_currency_iso }) => new_currency_iso,
      width: 80
    },

    {
      key: 'source',
      title: 'Source',
      render: (_, { source }) => <Tag>{source}</Tag>,
      width: 100
    },

    {
      key: 'changed_at',
      title: 'Changed',
      render: (_, { changed_at }) => <small>{formattedDate(changed_at).dateTime}</small>,
      width: 125
    },
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={LIMIT} />
    </div>
  )
}

export default _RateHistories;
